import * as React from "react";
import { useCallback } from "react";
import { EmptyList, TD } from "security-app/components/common";
import { GLCheckbox, RowTitleButton } from "common/components";
function ListRows({ ownerOptions, filters, ownerId, setOwnerId }) {
  const selectOwner = useCallback(
    (newOwner) => () => {
      const newOwnerId = newOwner.id;
      if (newOwnerId !== ownerId) {
        setOwnerId(newOwner.id);
      } else {
        setOwnerId(void 0);
      }
    },
    [ownerId, setOwnerId]
  );
  const strFilters = Object.fromEntries(Object.entries(filters).map(([key, values]) => [key, values.join(",")]));
  return ownerOptions.length < 1 ? /* @__PURE__ */ React.createElement(
    EmptyList,
    {
      filters: strFilters,
      noSearchResultText: "No User or Teams found for the provided criteria",
      noEntitiesExist: "Currently there are no User or Teams to list",
      colSpan: 3
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, ownerOptions.map((owner) => /* @__PURE__ */ React.createElement("tr", { key: owner.id }, /* @__PURE__ */ React.createElement(TD, null, /* @__PURE__ */ React.createElement(GLCheckbox, { checked: owner.id === ownerId, onChange: selectOwner(owner) })), /* @__PURE__ */ React.createElement(TD, null, /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: selectOwner(owner) }, owner.name)), /* @__PURE__ */ React.createElement(TD, null, owner.type))));
}
export default ListRows;
